import 'setimmediate';

const fork = setImmediate || setTimeout;

/**
 * Static class of utility functions, and the like.
 * 
 * @namespace Util
 */
class Util {
    /**
     * Check the viewport type, based on the specified breakpoints
     * 
     * @deprecated Use Util.getViewPort() instead.
     * @static
     * @param {number} [desktopBreakpoint=970] number
     * @param {number} [tabletBreakpoint=750] number
     * @returns {ViewPort} The viewport (desktop|mobile|tablet)
     * @memberof Util
     */
    static checkWidth(desktopBreakpoint, tabletBreakpoint) {
        // Util.deprecate('Util.checkWidth()', 'Use Util.getViewPort() instead')
        return Util.getViewPort(desktopBreakpoint, tabletBreakpoint);
    }

	/**
     * Check if the specified element is currently being viewed in the window
     * 
     * @static
     * @param {string|JObject} animationElements for animation
     * @param {string} container name of container
     * @returns {boolean} of status
     * @memberof Util
     */
    static checkIfInView(animationElements, container) {
        let windowHeight = $(window).height();
        let windowTopPosition = $(window).scrollTop() - 100;
        let windowBottomPosition = (windowTopPosition + windowHeight);

        for (let element of $(animationElements)) {
            let elementHeight = $(element).closest(container).outerHeight();
            let elemenTopPosition = $(element).closest(container).offset().top;
            let elementBottomPosition = (elemenTopPosition + elementHeight);

            // check to see if this current container is within viewport
            if ((elementBottomPosition >= windowTopPosition) &&
                (elemenTopPosition <= windowBottomPosition)) {
                return true;
            }
            else {
                return false;
            }
        }
    }

    /**
     * Debounce a function
     * 
     * @static
     * @param {function} func function to pass in
     * @param {number} [delay=150] delay of time
     * @param {boolean} [immediate=false] if should happen right away
     * @returns {function} that was passed in
     * @memberof Util
     */
    static debounce(func, delay, immediate) {
        delay = delay || 150;
        immediate = immediate === true || false;

        var timeout;
        return function () {
            var context = this;
            var args = arguments;

            var later = function () {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };

            var callNow = immediate && !timeout;
            window.clearTimeout(timeout);
            timeout = window.setTimeout(later, delay);
            if (callNow) {
                func.apply(context, args);
            }
        };
    }

    /**
     * Logs a depreciation notice to the console
     * 
     * @static
     * @param {string|function} method The name of the method, or the method being deprecated
     * @param {string} [message=''] An additional message
     * @memberof Util
     */
    static deprecate(method, message) {
        message = message || '';
        var name = method;

        if ('function' === typeof method) {
            name = method.name;
        }

        console.warn(`[Deprecation] ${name}. ${message}`);
    }

    /**
     * Throws an error if `window.$` or `window.jQuery` is undefined
     * 
     * @static
     * @memberof Util
     * @throws {ReferenceError}
     */
    static ensureJQuery() {
        if ('undefined' === typeof window.$ || 'undefined' === typeof window.jQuery) throw new ReferenceError('jQuery ($) is undefined. Please load jQuery before your bundle.');
    }

    /**
     * Set all elements in jquery-compatible selection to the height of the element in the collection with the largest height (within a row)
     * 
     * @static
     * @param {string|JObject} selector to check against
     * @memberof Util
     */
    static equalHeight(selector) {
        var currentTallest = 0;
        var currentRowStart = 0;
        var rowDivs = [];

        $(selector).each((i, el) => {
            var elem = $(el);
            elem.outerHeight('auto');
            var topPostion = elem.position().top;
            var currentDiv;

            if (currentRowStart !== topPostion) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].outerHeight(currentTallest);
                }
                rowDivs.length = 0; // empty the array
                currentRowStart = topPostion;
                currentTallest = elem.outerHeight();
                rowDivs.push(elem);
            } else {
                rowDivs.push(elem);
                currentTallest = currentTallest < elem.outerHeight() ? elem.outerHeight() : currentTallest;
            }
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].outerHeight(currentTallest);
            }
        });
    }

    /**
     * Set all elements within all selected classes to the height of the element with the largest height
     * 
     * @static
     * @param {string|JObject} selector of element
     * @memberof Util
     */
    static equalHeightAll(selector) {
        var currentTallest = 0;
        var currentRowStart = 0;
        var rowDivs = [];

        $(selector).each((i, el) => {
            var elem = $(el);
            elem.outerHeight('auto');
            var currentDiv;

            rowDivs.push(elem);
            currentTallest = currentTallest < elem.outerHeight() ? elem.outerHeight() : currentTallest;

            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].outerHeight(currentTallest);
            }
        });
    }

    static fork(task) {
        return new Promise((resolve, reject) => fork(() => {
            try {
                const result = task();
                resolve(task);
            } catch (err) {
                reject(err);
            }
        }));
    }

    /**
     * Get the value for a named query string parameter
     * 
     * @static
     * @param {string} name of property
     * @param {string} url string of url
     * @returns {object} of query string data
     * @memberof Util
     */
    static getQueryString(name, url) {
        if (!Util.hasValue(url)) url = window.location.href;

        name = name.replace(/[\[\]]/g, '\\$&');

        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        let results = regex.exec(url);

        if (!results) return null;
        if (!results[2]) return '';
        let value = decodeURIComponent(results[2].replace(/\+/g, ' '));
        return value;
    }

    /**
     * Get the viewport type, based on the specified breakpoints
     * 
     * @static
     * @param {number} [largeDesktopBreakpoint] pixel size for large desktop
     * @param {number} [desktopBreakpoint=970] pixel size for desktop
     * @param {number} [tabletBreakpoint=750] pixel size for tablet
     * @returns {ViewPort} The viewport (desktop|mobile|tablet)
     * @memberof Util
     */
    static getViewPort(largeDesktopBreakpoint, desktopBreakpoint, tabletBreakpoint) {
        desktopBreakpoint = desktopBreakpoint || 992;
        tabletBreakpoint = tabletBreakpoint || 621;

        var width = window.innerWidth;

        if (width >= desktopBreakpoint) {
            return ViewPort.Desktop;
        }
        else if (width >= tabletBreakpoint) {
            return ViewPort.Tablet;
        }
        return ViewPort.Mobile;
    }

    /**
     * Determine if `value` is NOT null, or undefined, or if `value` is a string, is NOT empty
     * 
     * @static
     * @param {any} value to check against
     * @returns {boolean} A boolean indication if `value` is not undefined, null, or an empty string
     * @memberof Util
     */
    static hasValue(value) {
        var hasValue = value !== undefined && value !== null;

        if (hasValue && 'string' === typeof value) {
            hasValue = hasValue && value !== "";
        }

        return hasValue;
    }

    /**
     * "polyfill" for requesting an idle callback
     * 
     * @static
     * @param {function} fn A callback function
     * @returns {Promise} A promise
     * @memberof Util
     */
    static requestIdleCallback(fn) {
        return new Promise(resolve => {
            const predicate = window.requestIdleCallback || window.requestAnimationFrame || window.setImmediate || window.setTimeout;
            predicate(() => resolve(fn()));
        });
    }

    /**
     * Set the value for a query string parameter. If url is empty, `window.location.href` is used, and will trigger navigation.
     * 
     * @static
     * @param {string} name The name of the parameter to set
     * @param {string} value The value for the parameter
     * @param {string} [url=window.location.href] The url to set the parameter
     * @returns {string} The `url` with the parameter set
     * @memberof Util
     */
    static setQueryString(name, value, url) {
        let _url = url;
        if (!Util.hasValue(url)) url = window.location.href;
        value = value.toString();

        let res = null;
        let re = new RegExp(`([?&])${name}=.*?(&|$)`, 'i');
        let separator = url.indexOf('?') !== -1 ? '&' : '?';
        if (url.match(re)) {
            res = url.replace(re, `$1${name}=${value}$2`);
        } else {
            res = `${url}${separator}${name}=${value}`;
        }

        if (!Util.hasValue(_url)) {
            window.location.href = res;
        } else {
            return res;
        }
    }

    /**
     * Set elements to equal height within their parent row containers (e.g., .nha-row)
     * More reliable than position-based row detection for complex CSS layouts
     * 
     * @static
     * @param {string|JObject} selector Elements to equalize
     * @param {string} [rowSelector='.nha-row'] Parent row container selector
     * @memberof Util
     */
    static equalHeightByRow(selector, rowSelector = '.nha-row') {
        // Reset all heights first
        $(selector).css('height', 'auto');
        
        // Group elements by their parent row container
        const rowGroups = new Map();
        
        $(selector).each((i, el) => {
            const $el = $(el);
            const $row = $el.closest(rowSelector);
            
            if ($row.length > 0) {
                const rowId = $row.get(0);
                
                if (!rowGroups.has(rowId)) {
                    rowGroups.set(rowId, []);
                }
                rowGroups.get(rowId).push($el);
            }
        });
        
        // Apply equal height within each row group
        rowGroups.forEach((elements, row) => {
            let maxHeight = 0;
            
            // Find the tallest element in this row
            elements.forEach($el => {
                const height = $el.outerHeight();
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });
            
            // Set all elements in this row to the max height
            elements.forEach($el => {
                $el.outerHeight(maxHeight);
            });
        });
    }

    /**
     * Trim whitespace from both sides of a string, as well as occurences of the specified character
     * 
     * @static
     * @param {string} str to trim against
     * @param {string} char to trim against
     * @returns {string} The trimmed string
     * @memberof Util
     */
    static trim(str, char) {
        if (str === null || str === undefined) return "";

        let value = str.trim();
        if (Util.hasValue(char)) value = value.replace(new RegExp(`(^${char}|${char}$)`, "g"), "");

        return value;
    }
}

export default Util;


/**
 * @enum {string} ViewPort
 * @memberof Util
 * @example
 * import Util, { ViewPort } from './util';
 * console.log(Util.getViewPort() === ViewPort.Desktop)  // -> true
 */
const ViewPort = {
    Desktop: 'desktop',
    Mobile: 'mobile',
    Tablet: 'tablet'
};
export { ViewPort };


Util.ensureJQuery();



// WEBPACK FOOTER //
// ./wwwroot/js/app/lib/util.js